export default __webpack_public_path__ + "static/media/siste.f32d3d0c.jpg";